import React from 'react';
import PropTypes from 'prop-types';
import cookieDough from 'cookie-dough';
import WebsiteSubscriptionCenterPage from 'website-subscription-center-page';
import SubscriptionCenterWidget from 'auth0-subscription-center-widget';

const cookie = cookieDough();

const updateCookieValues = (emailCampaigns, email) => {
  const hasSubscriptions = emailCampaigns.filter(item => item.subscribed);
  if (decodeURIComponent(cookie.get('email')) === email && hasSubscriptions.length === 0) {
    cookie.set('lastConsent', 'No');
  }
};

const PreferenceCenter = ({ email }) => (
  <WebsiteSubscriptionCenterPage email={email}>
    <SubscriptionCenterWidget
      apiUrl="https://dwh-tracking.it.auth0.com"
      onNewsLetterSend={updateCookieValues}
    />
  </WebsiteSubscriptionCenterPage>
);

PreferenceCenter.propTypes = {
  email: PropTypes.string
};

export default PreferenceCenter;



// WEBPACK FOOTER //
// ./src/pages/preference-center/containers/PreferenceCenter/PreferenceCenter.js